import React from 'react'
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Container, Paper, Typography } from '@mui/material';
import { useInit } from '../DataFetch/useInit';
import { usePreRegistration } from '../DataFetch/usePreRegistration';
import { useWorkRegistration } from '../DataFetch/useWorkRegistration';

/**
 * トップ画面
 */
export function Top() {

    const {init} = useInit();
    const {preRegistration} = usePreRegistration(init?.fiscalyear);
    const {workRegistration} = useWorkRegistration(init?.fiscalyear);

    return(
        <>
            <Typography
                variant="h6"
            >
                トップ
            </Typography>
            <Grid2 xs={12}>
                <Paper>
                    <Container maxWidth="xl">
                        <Typography
                            variant="body1"
                            p={1}
                            sx={{
                                textAlign:"left"
                            }}
                        >
                            {`有効年度：${init?.fiscalyear}`}<br/>
                            {`事前登録：${preRegistration?.length}件`}<br/>
                            {`本登録：${workRegistration?.length}件`}<br/>
                        </Typography>
                    </Container>
                </Paper>
            </Grid2>
        </>
    );
}